import axios from "axios";

import CreateDataRetrievalBegunAction from "./CreateDataRetrievalBegunAction";
import CreateDataRetrievalEndedAction from "./CreateDataRetrievalEndedAction";
import CheckResetLicenceApplicationTypeAction from "./CheckResetLicenceApplicationTypeAction";
import CreateGetRequiredEquipmentAction from "./CreateGetRequiredEquipmentAction";
import RefreshLicenceIsvalidAction from "./RefreshLicenceIsvalidAction";

export default function deleteEquipment(id, isNewAmendment) {
    return async (dispatch, getState) => {
        const { currentVessel, currentApplication } = getState();

        const licenceApplicationId = currentApplication.id ?? 0;
        const licenceStatusId = currentApplication.licenceApplicationStatusTypeId ?? 0;

        const url = isNewAmendment
            ? `api/EquipmentAmendment?id=${id}`
            : `api/Equipment?id=${id}`;

        dispatch(CreateDataRetrievalBegunAction());

        try {
            await axios.delete(url, {
                withCredentials: true
            });

            if (isNewAmendment) {
                dispatch(
                    CheckResetLicenceApplicationTypeAction(
                        licenceApplicationId,
                        currentVessel.id
                    )
                );
            }

            if (licenceStatusId > 1) {
                dispatch(
                    RefreshLicenceIsvalidAction(licenceApplicationId)
                );
            }

            dispatch(
                CreateGetRequiredEquipmentAction(licenceApplicationId)
            );
        } catch (error) {
            console.error("Failed to delete equipment", error);

            dispatch(CreateDataRetrievalEndedAction());
        }
    };
}